import React from 'react'
import _ from 'lodash'

import AutoCompleteInput from './AutoCompleteInput'
import DismissableListFilterTab from './DismissableListFilterTab'
import '../../../styles/scss/filters/input-filter.scss'

const InputFilter = ({
  availableFilters,
  currentFilters,
  label,
  onRemoveFilter,
  onSubmitInput,
  placeholder,
}) => {
  const availableFiltersList = _.map(availableFilters)
  const currentFiltersList = _.map(currentFilters, filter => availableFilters[filter])
  const suggestions = _.without(availableFiltersList, ...currentFiltersList)
  return (
    <>
      <div className="input-filter__autocomplete">
        <AutoCompleteInput
          className="input"
          name={`${label} Search`}
          onSubmit={onSubmitInput}
          placeHolder={placeholder}
          suggestions={suggestions}
        />
      </div>
      <div className="input-filter__filters">
        {_.map(currentFilters, filter => {
          return (
            <DismissableListFilterTab
              key={filter}
              label={availableFilters[filter]}
              onClick={() => onRemoveFilter(filter)}
            />
          );
        })}
      </div>
    </>
  )
}

export default InputFilter
